import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';
const SvgPerson = ({
  accessibilityText,
  forwardedRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: 24,
  height: 24,
  "aria-hidden": accessibilityText ? undefined : true,
  "aria-label": accessibilityText,
  fill: "currentColor",
  focusable: false,
  ref: forwardedRef,
  role: accessibilityText ? 'img' : undefined
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 3.9c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1S8.9 8.71 8.9 7s1.39-3.1 3.1-3.1M12 2C9.24 2 7 4.24 7 7s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m7 17c0-3.31-2.69-6-6-6h-2c-3.31 0-6 2.69-6 6v3h2v-3c0-2.21 1.79-4 4-4h2c2.21 0 4 1.79 4 4v3h2z"
}));
export default SvgPerson;